import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '../../shared/services/loader.service';
import { ApiService } from '../../shared/services/api.service';

@Component({
  selector: 'app-compare',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './compare.component.html',
  styleUrl: './compare.component.scss',
})
export class CompareComponent implements OnInit, OnDestroy {
  @ViewChild('brandInput') brandInput!: ElementRef;
  @ViewChild('modelInput') modelInput!: ElementRef;
  @ViewChild('dropdownContainer') dropdownContainer!: ElementRef;
  @ViewChild('dropdownContainermodel') dropdownContainermodel!: ElementRef;
  @ViewChild('variantInput') variantInput!: ElementRef;
  @ViewChild('dropdownContainervariant') dropdownContainervariant!: ElementRef;
  @ViewChild('dropdownContainerYear') dropdownContainerYear!: ElementRef;
  @ViewChild('dropdownYear') dropdownYear!: ElementRef;
  sub: Subscription = new Subscription();
  searchData: VehicleSearch = {};
  dropdownVisibleYear = false;
  isregistrationNoValid: boolean = false;
  years: any[] = [];

  brands = [
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/d99f132bcd5ba1648f49b2f0504471a2bfc63182?placeholderIfAbsent=true',
      name: 'Tata',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/4854c1a30cca6bf3d61fc8c5fb3bac9f6e6e8f5f?placeholderIfAbsent=true',
      name: 'Suzuki',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/eb1757ac970fea0b8cda8dc57fb2714910f4a02b?placeholderIfAbsent=true',
      name: 'Audi',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/d3fa6771e9469bd85b1a595ea3273cc97bf4d359?placeholderIfAbsent=true',
      name: 'Ashok Leyland',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/3310ac8d2789ddcd4fb8b98dc257aa8ea7552313?placeholderIfAbsent=true',
      name: 'Volkswagen',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/7fa4ff48b5f0b8229e9e1b2edffd7e79a48cae3a?placeholderIfAbsent=true',
      name: 'Toyota',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/963abfb9a9ccbbb2ebe0778f0c256ca253e31bd1?placeholderIfAbsent=true',
      name: 'Mercedes',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/bb655f0d30952da04de2620bcbe03b2c94127d24?placeholderIfAbsent=true',
      name: 'Lexus',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/2ea9c47bf0fa448d7f366a697abea74c9d9a18f7?placeholderIfAbsent=true',
      name: 'Kia',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/e44d078afb0956f88d21a7fe798dfc8076283b59?placeholderIfAbsent=true',
      name: 'Hyundai',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/d3fa6771e9469bd85b1a595ea3273cc97bf4d359?placeholderIfAbsent=true',
      name: 'Ashok Leyland',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/9f213b52fa9dbd02fec68fe765448ed8cff7c9b8?placeholderIfAbsent=true',
      name: 'Ford',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/8432f50ea8f00b208faed48fa8f4b603c7a319c2?placeholderIfAbsent=true',
      name: 'BMW',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/3e84b67fbb8012fe125236b3d171e6572f240f22?placeholderIfAbsent=true',
      name: 'Chevrolet',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/ad9663eb9c87fcb5002bb04412c2eca8c898a634?placeholderIfAbsent=true',
      name: 'Hero',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/e44d078afb0956f88d21a7fe798dfc8076283b59?placeholderIfAbsent=true',
      name: 'Hyundai',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/4854c1a30cca6bf3d61fc8c5fb3bac9f6e6e8f5f?placeholderIfAbsent=true',
      name: 'Suzuki',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/eb1757ac970fea0b8cda8dc57fb2714910f4a02b?placeholderIfAbsent=true',
      name: 'Audi',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/d3fa6771e9469bd85b1a595ea3273cc97bf4d359?placeholderIfAbsent=true',
      name: 'Ashok Leyland',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/3310ac8d2789ddcd4fb8b98dc257aa8ea7552313?placeholderIfAbsent=true',
      name: 'Volkswagen',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/7fa4ff48b5f0b8229e9e1b2edffd7e79a48cae3a?placeholderIfAbsent=true',
      name: 'Toyota',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/963abfb9a9ccbbb2ebe0778f0c256ca253e31bd1?placeholderIfAbsent=true',
      name: 'Mercedes',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/bb655f0d30952da04de2620bcbe03b2c94127d24?placeholderIfAbsent=true',
      name: 'Lexus',
    },
  ];

  dropdownVisible = false;
  dropdownVisiblemodel = false;
  dropdownVisiblevariant = false;
  searchEvent: any;
  showVehiclePopup = false;
  vehicleTitle = 'Tata Ace Gold, 2017, 1.4L (BS-IV, Diesel)';
  vehicleImage =
    'https://cdn.builder.io/api/v1/image/assets/TEMP/1b7d948e33a2c1d90c482039e4f08330af60fdea?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7';
  closeIconUrl =
    'https://cdn.builder.io/api/v1/image/assets/TEMP/e3f9dae9aedb57f6f7418ae326e3bda1a77ba4e0?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7';
  vehicleDetails: any;

  modelList: any = {};
  brandsList: any[] = [];
  filteredBrandsList: any[] = [];
  selectedBrandmodelList: any[] = [];
  selectedModelVariantList: any[] = [];
  isLoadingBrands = false;
  searchTimeout: any;

  // Variant dropdown data
  fuelTypes = ['Petrol', 'Diesel', 'CNG'];
  selectedFuelType = '';
  variantData = {
    fuelTypes: ['Petrol', 'Diesel', 'CNG'],
    variants: ['1.5L (BS4-Diesel)'],
  };

  // Field enable/disable states
  isModelEnabled = false;
  isYearEnabled = false;
  isVariantEnabled = false;
  isButtonEnabled = false;
  modelimages: any;
  searchVehiclesdata: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    private apiService: ApiService,
  ) {
    // Generate years for the dropdown (e.g., last 30 years)
    const currentYear = new Date().getFullYear();
    for (let i = 0; i < 30; i++) {
      this.years.push(currentYear - i);
    }
  }

  ngOnInit() {
    this.generateYears();
    this.getBrandVehicleList();

    // Set initial field states
    this.isModelEnabled = false;
    this.isYearEnabled = false;
    this.isVariantEnabled = false;
    this.updateButtonState();
  }

  ngOnDestroy() {
    // Clear timeout to prevent memory leaks
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    this.sub.unsubscribe();
    // Ensure body scroll is unlocked on component destroy
    this.unlockBodyScroll();
  }

  resetDownstreamFields() {
    // Reset all fields that come after the current selection
    this.searchData.model = '';
    this.searchData.year = '';
    this.searchData.variant = '';
    this.isModelEnabled = false;
    this.isYearEnabled = false;
    this.isVariantEnabled = false;
    this.updateButtonState();
  }

  handleClose() {
    this.showVehiclePopup = false;
    this.isregistrationNoValid = false;
    this.unlockBodyScroll();
  }

  handleCancel() {
    this.showVehiclePopup = false;
    this.searchData.brand = '';
    this.searchData.model = '';
    this.searchData.year = '';
    this.searchData.variant = '';
    this.isModelEnabled = false;
    this.isYearEnabled = false;
    this.isVariantEnabled = false;
    this.isregistrationNoValid = false;
    this.unlockBodyScroll();
  }

  handleConfirm() {
    localStorage.removeItem('category');
    localStorage.removeItem('filterState');
    localStorage.removeItem('guideSearchData');
    localStorage.removeItem('seemore');
    localStorage.removeItem('MyGarageData');
    localStorage.removeItem('SpareCategory');
    localStorage.removeItem('mostSearchedModel');
    localStorage.setItem('SpareCategory', JSON.stringify(this.vehicleDetails));

    // localStorage.setItem('category', JSON.stringify(this.vehicleDetails));
    // localStorage.setItem('categoryType', JSON.stringify('spareParts'));
    // Do something with confirmation
    this.showVehiclePopup = false;
    this.searchData.brand = '';
    this.searchData.model = '';
    this.searchData.year = '';
    this.searchData.variant = '';
    this.isModelEnabled = false;
    this.isYearEnabled = false;
    this.isVariantEnabled = false;
    this.showVehiclePopup = false;
    this.router.navigate(['/product-list']);
  }

  openVehiclePopup() {
    this.showVehiclePopup = true;
  }

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: MouseEvent): void {
    const clickedInsideBrand =
      this.dropdownContainer?.nativeElement.contains(event.target) ||
      this.brandInput?.nativeElement.contains(event.target);
    const clickedInsideModel =
      this.dropdownContainermodel?.nativeElement.contains(event.target) ||
      this.modelInput?.nativeElement.contains(event.target);
    const clickedInsideVariant =
      this.dropdownContainervariant?.nativeElement.contains(event.target) ||
      this.variantInput?.nativeElement.contains(event.target);
    const clcikdropdownContainerYear =
      this.dropdownContainerYear?.nativeElement.contains(event.target) ||
      this.dropdownYear?.nativeElement.contains(event.target);

    if (!clickedInsideBrand) {
      this.dropdownVisible = false;
    }

    if (!clickedInsideModel) {
      this.dropdownVisiblemodel = false;
    }

    if (!clickedInsideVariant) {
      this.dropdownVisiblevariant = false;
    }

    if (!clcikdropdownContainerYear) {
      this.dropdownVisibleYear = false;
    }
  }

  openDropdown(): void {
    this.dropdownVisible = true;
    // Reset filtered brands list to show all brands when dropdown is opened
    this.filteredBrandsList = [...this.brandsList];
  }

  openDropdownmodel(): void {
    // Always open the dropdown (avoid toggle to prevent double event close on focus+click)
    this.dropdownVisiblemodel = true;

    // If opening the dropdown
    if (this.dropdownVisiblemodel) {
      // Check if we have a brand selected
      if (!this.searchData.brand || !this.isModelEnabled) {
        // Dropdown will open but show message that brand needs to be selected
        return;
      }

      // If we have a brand, ensure models are loaded
      if (
        !this.selectedBrandmodelList ||
        this.selectedBrandmodelList.length === 0
      ) {
        this.getModelVehicleList(this.searchData.brand);
      }
    }
  }

  openDropdownvariant(): void {
    if (!this.isVariantEnabled) return;
    // Always open the dropdown (avoid toggle to prevent double event close on focus+click)
    this.dropdownVisiblevariant = true;
    if (this.dropdownVisiblevariant && this.searchData.model) {
      // Get variants for the selected model if not already loaded
      if (
        !this.selectedModelVariantList ||
        this.selectedModelVariantList.length === 0
      ) {
        this.getVariantVehicleList(this.searchData.model);
      }
    }
  }

  search(): void {
    this.searchData.model = '';
    this.searchEvent.emit(this.searchData);
  }

  selectBrand(name: string) {
    this.searchData.brand = name;
    this.searchData.registrationNo = ''; // Clear registration number when brand is manually selected
    this.dropdownVisible = false;

    // Reset filtered brands list to show all brands
    this.filteredBrandsList = [...this.brandsList];

    // Reset downstream fields
    this.resetDownstreamFields();

    // Enable model field when brand is selected
    this.isModelEnabled = true;

    // Get models for the selected brand
    this.getModelVehicleList(name);

    // Update button state
    this.updateButtonState();
  }

  selectModel(model: string) {
    this.searchData.model = model;
    this.dropdownVisiblemodel = false;

    // Reset year and variant fields
    this.searchData.year = '';
    this.searchData.variant = '';
    this.isYearEnabled = true;
    this.isVariantEnabled = false;
    this.getYear();
    this.updateButtonState();
  }

  selectVariant(variant: string) {
    this.searchData.variant = variant;
    // Get vehicle details for the selected variant
    this.getVehicle();
  }

  selectFuelType(fuelType: string) {
    this.selectedFuelType = fuelType;
    // Filter variants based on selected fuel type
    this.filterVariantsByFuelType(fuelType);
  }

  clearFuelTypeFilter() {
    this.selectedFuelType = '';
    this.variantData.variants = this.selectedModelVariantList;
  }

  filterVariantsByFuelType(fuelType: string) {
    // Filter variants that contain the selected fuel type
    if (fuelType) {
      this.variantData.variants = this.selectedModelVariantList.filter(
        (variant) => variant.toLowerCase().includes(fuelType.toLowerCase()),
      );
    } else {
      // If no fuel type selected, show all variants
      this.variantData.variants = this.selectedModelVariantList;
    }
  }

  selectVariantFromDropdown(variant: string) {
    this.searchData.variant = variant;
    this.dropdownVisiblevariant = false;
  }

  onYearChange() {
    // Enable variant field when year is selected
    if (this.searchData.year) {
      this.getVariantVehicleList(this.searchData.model);
      this.isVariantEnabled = true;
    } else {
      this.isVariantEnabled = false;
      this.searchData.variant = '';
    }
  }

  generateYears() {
    const currentYear = new Date().getFullYear();
    for (let i = 0; i < 30; i++) {
      this.years.push(currentYear - i);
    }
  }

  getBrandVehicleList() {
    this.isLoadingBrands = true;
    this.loaderService.show();
    const payload = {
      action_type: 'make',
    };
    this.sub.add(
      this.apiService.getBrand(payload).subscribe({
        next: (response: any) => {
          this.loaderService.hide();
          this.isLoadingBrands = false;
          if (response && response.data) {
            this.modelList = response?.data?.Vehicle_Brands;
            this.brandsList = this.transformModelListToBrandsList(
              this.modelList,
            );
            this.filteredBrandsList = [...this.brandsList]; // Initialize filtered list with all brands
          }
        },
        error: (error: any) => {
          this.loaderService.hide();
          this.isLoadingBrands = false;
          console.error('Error fetching brand list:', error);
        },
      }),
    );
  }

  // Filter brands based on user input
  // This method filters the brands list to show only brands that start with the search term
  filterBrands(searchTerm: string): void {
    if (!searchTerm || searchTerm.trim() === '') {
      this.filteredBrandsList = [...this.brandsList];
      return;
    }

    const searchLower = searchTerm.toLowerCase().trim();
    const filteredList: any[] = [];

    this.brandsList.forEach((column) => {
      const filteredColumn = column.filter((section: any) => {
        // Check if any brand in this section starts with the search term
        return section.brands.some((brand: string) =>
          brand.toLowerCase().startsWith(searchLower),
        );
      });

      if (filteredColumn.length > 0) {
        // Create a new column with only the matching sections
        const newColumn = filteredColumn.map((section: any) => ({
          letter: section.letter,
          brands: section.brands.filter((brand: string) =>
            brand.toLowerCase().startsWith(searchLower),
          ),
        }));
        filteredList.push(newColumn);
      }
    });

    this.filteredBrandsList = filteredList;
  }

  // Transform modelList to a format suitable for the template
  transformModelListToBrandsList(modelList: any): any[] {
    const transformedList: any[] = [];

    // Sort the keys alphabetically
    const sortedKeys = Object.keys(modelList).sort();

    // Group brands into columns (7 columns as in the original template)
    const brandsPerColumn = Math.ceil(sortedKeys.length / 7);

    for (let i = 0; i < sortedKeys.length; i += brandsPerColumn) {
      const column = sortedKeys.slice(i, i + brandsPerColumn).map((letter) => ({
        letter: letter.toUpperCase(),
        brands: modelList[letter] || [],
      }));
      transformedList.push(column);
    }

    return transformedList;
  }

  // Get popular brands from the modelList data
  getPopularBrands(searchTerm?: string): any[] {
    if (!this.modelList) return [];

    const popularBrandNames = [
      'TATA',
      'MARUTI',
      'HYUNDAI',
      'HONDA',
      'TOYOTA',
      'BMW',
      'AUDI',
      'MERCEDES',
    ];
    const popularBrands: any[] = [];

    // Create a mapping of brand names to their default images
    const brandImageMap: { [key: string]: string } = {
      TATA: 'https://cdn.builder.io/api/v1/image/assets/TEMP/d99f132bcd5ba1648f49b2f0504471a2bfc63182?placeholderIfAbsent=true',
      MARUTI:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/4854c1a30cca6bf3d61fc8c5fb3bac9f6e6e8f5f?placeholderIfAbsent=true',
      HYUNDAI:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/e44d078afb0956f88d21a7fe798dfc8076283b59?placeholderIfAbsent=true',
      HONDA:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/eb1757ac970fea0b8cda8dc57fb2714910f4a02b?placeholderIfAbsent=true',
      TOYOTA:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/7fa4ff48b5f0b8229e9e1b2edffd7e79a48cae3a?placeholderIfAbsent=true',
      BMW: 'https://cdn.builder.io/api/v1/image/assets/TEMP/8432f50ea8f00b208faed48fa8f4b603c7a319c2?placeholderIfAbsent=true',
      AUDI: 'https://cdn.builder.io/api/v1/image/assets/TEMP/eb1757ac970fea0b8cda8dc57fb2714910f4a02b?placeholderIfAbsent=true',
      MERCEDES:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/963abfb9a9ccbbb2ebe0778f0c256ca253e31bd1?placeholderIfAbsent=true',
    };

    // Find brands from modelList that match popular brand names
    for (const brandName of popularBrandNames) {
      // If search term is provided, only include brands that start with the search term
      if (
        searchTerm &&
        !brandName.toLowerCase().startsWith(searchTerm.toLowerCase())
      ) {
        continue;
      }

      for (const letter in this.modelList) {
        if (this.modelList[letter].includes(brandName)) {
          popularBrands.push({
            name: brandName,
            imageUrl:
              brandImageMap[brandName] ||
              'https://cdn.builder.io/api/v1/image/assets/TEMP/d99f132bcd5ba1648f49b2f0504471a2bfc63182?placeholderIfAbsent=true',
          });
          break;
        }
      }
    }

    return popularBrands;
  }

  getModelVehicleList(selectedBrand?: string) {
    const payload = {
      action_type: 'model',
      make_list: [selectedBrand || this.searchData.brand || ''],
    };
    this.loaderService.show();
    this.sub.add(
      this.apiService.getBrand(payload).subscribe((res: any) => {
        if (res?.data?.Vehicle_Models) {
          const modelData = res?.data?.Vehicle_Models;

          // Merge both numeric and letter key arrays into one flat array
          const allModels = [
            ...Object.keys(modelData)
              .filter((key) => /^\d+$/.test(key) || /^[a-zA-Z]$/.test(key))
              .flatMap((key) => modelData[key]),
          ];

          // Group all models alphabetically (A-Z)
          const modelsByLetter = this.groupModelsAlphabetically(allModels);

          this.selectedBrandmodelList = modelsByLetter; // Now just an array of { letter: string, models: string[] }

          this.modelimages = res?.data?.image_data;
        } else {
          this.selectedBrandmodelList = [];
        }
        this.loaderService.hide();
      }),
    );
  }

  // Helper method to group models alphabetically
  groupModelsAlphabetically(models: string[]): any[] {
    const grouped: { [key: string]: string[] } = {};

    models.forEach((model) => {
      const firstLetter = model.charAt(0).toUpperCase();
      if (!grouped[firstLetter]) {
        grouped[firstLetter] = [];
      }
      grouped[firstLetter].push(model);
    });

    // Convert to array format and sort
    return Object.keys(grouped)
      .sort()
      .map((letter) => ({
        letter: letter,
        models: grouped[letter].sort(),
      }));
  }

  getVariantVehicleList(selectedModel?: string) {
    const payload = {
      action_type: 'variant',
      make_list: [this.searchData.brand || ''],
      model_list: [selectedModel || this?.searchData?.model || ''],
      variant_list: [],
      year_of_manufacture: this.searchData?.year || '',
      offset: 0,
      limit: 10,
    };
    this.loaderService.show();
    this.sub.add(
      this.apiService.getBrand(payload).subscribe((res: any) => {
        // Transform the response to handle both numeric and letter keys
        if (res?.data) {
          const variantData = res?.data?.Vehicle_Variant;
          const allVariants: string[] = [];

          // Extract all variants from the response (both numeric and letter keys)
          Object.keys(variantData).forEach((key) => {
            if (Array.isArray(variantData[key])) {
              allVariants.push(...variantData[key]);
            }
          });

          // Sort variants alphabetically for better user experience
          this.selectedModelVariantList = allVariants.sort((a, b) =>
            a.localeCompare(b),
          );

          // Update the variant data for the dropdown
          this.variantData.variants = this.selectedModelVariantList;
        } else {
          this.selectedModelVariantList = [];
          this.variantData.variants = [];
        }

        this.loaderService.hide();
      }),
    );
  }

  getVehicle() {
    const payload = {
      action_type: 'Get Vehicle Details',
      make_list: [this.searchData.brand || ''],
      model_list: [this.searchData.model || ''],
      variant_list: [this.searchData.variant || ''],
      year_of_manufacture: this.searchData?.year || '',
      offset: 0,
      limit: 10,
    };
    this.loaderService.show();
    this.sub.add(
      this.apiService.getBrand(payload).subscribe((res: any) => {
        if (res.success) {
          this.onAdd();
          this.openVehiclePopup();
          this.vehicleDetails = res?.data?.Vehicle_Data[0];
          this.searchVehiclesdata = true;
          this.loaderService.hide();
        } else {
          this.searchVehiclesdata = false;
          this.showVehiclePopup = true;
          this.loaderService.hide();
        }
      }),
    );
  }

  toggleYearGrid() {
    this.dropdownVisibleYear = !this.dropdownVisibleYear;
  }

  selectYear(year: number) {
    this.searchData.year = year.toString(); // or just year if it's a number
    this.dropdownVisibleYear = false;
    this.onYearChange(); // optional if you still want a manual trigger
  }

  updateButtonState() {
    // Enable button if:
    // 1. Registration number has 8 or more characters, OR
    // 2. Brand and model are selected (for manual selection)
    const hasValidRegistrationNo =
      this.searchData.registrationNo &&
      this.searchData.registrationNo.length == 10;
    const hasBrandAndModel = this.searchData.brand && this.searchData.model;

    this.isButtonEnabled = !!(hasValidRegistrationNo || hasBrandAndModel);
  }

  // onRegistrationNoChange(): void {
  //   this.updateButtonState();

  //   if (this.searchData.registrationNo) {
  //     this.searchData.brand = '';
  //   }
  // }

  onRegistrationNoChange(registrationNo?: string): void {
    // Convert registration number to uppercase
    if (registrationNo) {
      registrationNo = registrationNo.toUpperCase();
      this.searchData.registrationNo = registrationNo;
    }

    // Reset form values if registrationNo is less than 8 characters
    if (!registrationNo || registrationNo.length != 10) {
      // Reset all bound form values
      this.searchData.brand = '';
      this.searchData.model = '';
      this.searchData.year = '';
      this.searchData.variant = '';
      this.isModelEnabled = false;
      this.isYearEnabled = false;
      this.isVariantEnabled = false;
      this.updateButtonState();
      return;
    }

    // Only call API when registrationNo has 8 or more characters
    if (registrationNo && registrationNo.length == 10) {
      const payload = {
        reg_no: registrationNo,
        action_type: 'Get Vehicle Details',
      };
      // this.isregistrationNoValid = true
      this.loaderService.show();
      this.sub.add(
        this.apiService.getBrand(payload).subscribe({
          next: (res: any) => {
            if (res.success) {
              this.loaderService.hide();

              if (res && res.data) {
                // Bind response data to form fields
                if (res.data.Vehicle_Data[0]) {
                  this.searchData.brand =
                    res.data.Vehicle_Data[0].VEHICLE_MAKE_s;
                  this.searchData.variant = res.data.Vehicle_Data[0].VARIANT_s;
                  this.searchData.model =
                    res.data.Vehicle_Data[0].PARENT_MODEL_s;
                  this.searchData.year =
                    res.data.Vehicle_Data[0].YEAR_OF_MANUFACTURE_s;
                  this.isModelEnabled = true;
                }

                if (
                  res.data.Vehicle_Data[0].VEHICLE_MAKE_s &&
                  res.data.Vehicle_Data[0].PARENT_MODEL_s &&
                  res.data.Vehicle_Data[0].VARIANT_s &&
                  res.data.Vehicle_Data[0].YEAR_OF_MANUFACTURE_s
                ) {
                  this.getVehicle();
                }

                // Update button state after binding
                this.updateButtonState();
                this.showVehiclePopup = true;
              }
            } else {
              this.showVehiclePopup = true;
              this.searchVehiclesdata = false;
              // this.isregistrationNoValid = true;
              // this.lockBodyScroll();
              this.loaderService.hide();
            }
          },
          error: (error: any) => {
            this.showVehiclePopup = true;
            this.searchVehiclesdata = false;
            // this.lockBodyScroll();
            this.loaderService.hide();
            console.error('Error fetching vehicle details:', error);
          },
        }),
      );
    }
  }

  onBrandChange(): void {
    if (this.searchData.brand) {
      // Clear registration number when brand is manually selected
      this.searchData.registrationNo = '';
      // Clear previous timeout
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      // Debounce the search to avoid too many filter operations
      this.searchTimeout = setTimeout(() => {
        this.filterBrands(this.searchData.brand || '');
      }, 300); // 300ms delay
    } else {
      // If brand input is empty, show all brands immediately
      this.filteredBrandsList = [...this.brandsList];
    }
    this.updateButtonState();
  }

  onAdd() {
    const payload = {
      part_no: '',
      model: this.searchData?.model || '',
      make: this.searchData?.brand || '',
      vehicle_variant: this.searchData?.variant || '',
      year: this.searchData?.year || '',
      fuel_type: '',
    };
    this.loaderService.show();
    this.sub.add(
      this.apiService.addModelSearch(payload).subscribe((res: any) => {
        if (res.success) {
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      }),
    );
  }

  getYear() {
    this.isLoadingBrands = true;
    this.loaderService.show();
    const payload = {
      // "dropdown_type": "vehicle_brand"
      action_type: 'year_of_manufacture',
      make_list: [this.searchData.brand || ''],
      model_list: [this.searchData.model || ''],
      variant_list: '', //[this.searchData.variant || ""],
      year_of_manufacture: this.searchData?.year || '',
      offset: 0,
      limit: 1000,
    };
    this.sub.add(
      this.apiService.getBrand(payload).subscribe({
        next: (response: any) => {
          this.loaderService.hide();
          this.isLoadingBrands = false;
          if (response && response.data) {
            this.years = response?.data?.Vehicle_Year?.map(
              (item: any) => item?.YEAR_OF_MANUFACTURE_s,
            );
          }
        },
        error: (error: any) => {
          this.loaderService.hide();
          this.isLoadingBrands = false;
          console.error('Error fetching brand list:', error);
        },
      }),
    );
  }

  compatibleVehicles = [
    {
      model: 'Santro Xing 2ND Gen 1.1L',
      year: '05/2003 - 04/2004',
      engine: {
        capacity: '1.1L',
        type: 'SOHC MPFI',
      },
      power: '62 h.p.',
      fuelType: 'Petrol',
    },
    {
      model: 'Santro Xing 2ND Gen 1.1L',
      year: '05/2003 - 04/2004',
      engine: {
        capacity: '1.1L',
        type: 'SOHC MPFI',
      },
      power: '62 h.p.',
      fuelType: 'Petrol',
    },
    {
      model: 'Santro Xing 2ND Gen 1.1L',
      year: '05/2003 - 04/2004',
      engine: {
        capacity: '1.1L',
        type: 'SOHC MPFI',
      },
      power: '62 h.p.',
      fuelType: 'Petrol',
    },
    {
      model: 'Santro Xing 2ND Gen 1.1L',
      year: '05/2003 - 04/2004',
      engine: {
        capacity: '1.1L',
        type: 'SOHC MPFI',
      },
      power: '62 h.p.',
      fuelType: 'Petrol',
    },
    {
      model: 'Santro Xing 2ND Gen 1.1L',
      year: '05/2003 - 04/2004',
      engine: {
        capacity: '1.1L',
        type: 'SOHC MPFI',
      },
      power: '62 h.p.',
      fuelType: 'Petrol',
    },
  ];

  activeBrand: string = 'Hyundai'; // Default selected
  otherCompatibleBrands = [
    { name: 'Hyundai', count: 3 },
    { name: 'Maruti', count: 2 },
    { name: 'Toyota', count: 0 },
  ];

  selectCompatibleBrand(brandName: string): void {
    this.activeBrand = brandName;
  }

  closeAllDropdowns(): void {
    this.dropdownVisible = false;
    this.dropdownVisiblemodel = false;
    this.dropdownVisibleYear = false;
    this.dropdownVisiblevariant = false;
  }

  vehicleName = 'Tata Ace Zip';
  searchdata: boolean = false;
  response: boolean = false;

  searchData1 = {
    registrationNo: '',
    brand: '',
    model: '',
    year: '',
    variant: '',
  };

  viewRelatedParts(vehicle?: any): void {
    // Prepare vehicle data for navigation
    // Use searchData or vehicleDetails for make if available, otherwise use activeBrand or leave empty
    const make =
      this.searchData?.brand ||
      this.vehicleDetails?.make ||
      this.activeBrand ||
      '';

    const MyGarageData = {
      model: vehicle?.model || '',
      year_of_manufacturing: vehicle?.year || '',
      make: make,
      variant: this.searchData?.variant || this.vehicleDetails?.variant || '',
      part_type: 'Used Part',
    };

    // Clear previous navigation data
    localStorage.removeItem('category');
    localStorage.removeItem('seemore');
    localStorage.removeItem('categoryType');
    localStorage.removeItem('guideSearchData');
    localStorage.removeItem('mostSearchedModel');
    localStorage.removeItem('SpareCategory');
    localStorage.removeItem('filterState');
    localStorage.removeItem('MyGarageData');

    // Store vehicle data for product list to use
    localStorage.setItem('MyGarageData', JSON.stringify(MyGarageData));

    // Navigate to product list page
    this.router.navigate(['/product-list']);
  }

  changeVehicle(): void {
    this.searchdata = true;
    this.response = false;
    this.searchVehiclesdata = false;
    this.showVehiclePopup = false;
    this.searchData.model = '';
    this.searchData.year = '';
    this.searchData.variant = '';
    this.searchData.brand = '';
    this.searchData.registrationNo = '';
    this.isModelEnabled = false;
    this.isYearEnabled = false;
    this.isVariantEnabled = false;
    this.updateButtonState();
    // Implement vehicle change logic here
  }

  searchVehicles(event: any) {
    this.searchdata = true;
    this.response = true;
    const searchTerm = event.target.value.toLowerCase();
    this.compatibleVehicles = this.compatibleVehicles.filter((vehicle) => {
      return (
        vehicle.model.toLowerCase().includes(searchTerm) ||
        vehicle.year.toLowerCase().includes(searchTerm)
      );
    });
  }

  tryAgain() {
    this.searchData.model = '';
    this.searchData.year = '';
    this.searchData.variant = '';
    this.searchData.brand = '';
    this.searchdata = false; // just to reset the search data
    this.response = false;
    this.searchVehiclesdata = false;
    this.showVehiclePopup = false;
  }

  lockBodyScroll(): void {
    // Prevent body scroll when popup is open
    if (typeof document !== 'undefined') {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    }
  }

  unlockBodyScroll(): void {
    // Restore body scroll when popup is closed
    if (typeof document !== 'undefined') {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    }
  }

  preventInvalidInput(event: any) {
    let value = event.target.value;

    // Block leading space
    value = value.replace(/^\s+/, '');

    // Block special characters (allow only A-Z and 0-9)
    value = value.replace(/[^A-Za-z0-9]/g, '');

    // Convert to uppercase automatically
    value = value.toUpperCase();

    event.target.value = value;
    this.searchData.registrationNo = value;
  }
}
export interface VehicleSearch {
  registrationNo?: string;
  brand?: string;
  model?: string;
  year?: string;
  variant?: string;
}

export interface Brand {
  name: string;
  imageUrl: string;
}

export interface AlphabetSection {
  letter: string;
  brands: string[];
}
